/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-16T15:24:16.936
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentTakeLookEvaluate,
	getRentTakeLookEvaluateCreateInit,
	getRentTakeLookEvaluateEditInit,
	getRentTakeLookEvaluateView,
	deleteRentTakeLookEvaluate
} from '@api/rentmanage/RentTakeLookEvaluate';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentTakeLookEvaluateCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentTakeLookEvaluateCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentTakeLookEvaluateEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTakeLookEvaluateEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentTakeLookEvaluate({}, RentTakeLookEvaluate) {
			return new Promise((resolve, reject) => {
				saveRentTakeLookEvaluate(RentTakeLookEvaluate)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentTakeLookEvaluateView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTakeLookEvaluateView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentTakeLookEvaluate({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentTakeLookEvaluate({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
